
import { Component, Inject, Vue } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import type { Navigation } from 'zr-arch';
import Services from '@/infrastructure/service';
import Exceljs from 'exceljs';

@Component({})
export default class PaymentManage extends Vue {
    @Inject(Service) service!: Services;
    @Inject(Navigator) navigator!: Navigation;

    private loading = false;
    private processing = false;
    private batchProcessing = false;
    private exporting = false;
    private exportingPhotos = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private exams: any[] = [];
    private selectedExamId = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private items: any[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private selected: any[] = [];

    private headers = [
        { text: '序号', value: '序号', sortable: false, width: '60px' },
        { text: '专家姓名', value: '专家姓名', sortable: false },
        { text: '身份证号码', value: '身份证号码', sortable: false },
        { text: '手机号码', value: '手机号码', sortable: false },
        { text: '收款银行', value: '收款银行', sortable: false },
        { text: '银行卡号', value: '收款银行卡号', sortable: false },
        { text: '登记时间', value: '登记时间', sortable: false },
        { text: '状态', value: '状态', sortable: false },
        { text: '打款金额', value: '打款金额', sortable: false },
        { text: '打款时间', value: '打款时间', sortable: false },
        { text: '操作', value: 'actions', sortable: false, width: '140px' },
    ];

    private payDialog = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private currentItem: any = {};
    private paymentForm = { 打款金额: 0 };

    private batchPayDialog = false;
    private batchPaymentForm = { 打款金额: 0 };

    private photoDialog = false;
    private photoLoading = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private photoDialogItem: any = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private photoUrls: Record<string, string | null> = {};
    private photoTypes = ['身份证正面', '身份证反面', '本人照片'];

    private fullPreviewDialog = false;
    private fullPreviewUrl = '';

    async mounted(): Promise<void> {
        await this.loadExams();
    }

    async loadExams(): Promise<void> {
        const result = await this.service.api.get('/ExpertColl/Manage/ExamManage/GetExamList', {
            pageIndex: '1',
            pageSize: '100',
        });
        this.exams = (result && result.data) || [];
    }

    async reload(): Promise<void> {
        await this.loadExams();
        if (this.selectedExamId) {
            await this.loadList();
        }
    }

    async loadList(): Promise<void> {
        if (!this.selectedExamId) return;
        this.loading = true;
        try {
            this.items = (await this.service.api.get('/ExpertColl/Manage/PaymentManage/GetExpertList', {
                examId: this.selectedExamId,
            })) || [];
        } finally {
            this.loading = false;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async openPaymentDialog(item: any): Promise<void> {
        this.currentItem = item;
        const exam = this.exams.find((e) => e.id === this.selectedExamId);
        this.paymentForm.打款金额 = item.打款金额 || exam?.默认打款金额 || 0;
        this.payDialog = true;
    }

    async doPayment(状态: string): Promise<void> {
        if (
            !(await this.service.提示.确认操作(
                `您确定要执行「${状态}」操作吗？`,
                '警告',
                '打款操作'
            ))
        ) {
            return;
        }
        this.processing = true;
        try {
            await this.service.api.post('/ExpertColl/Manage/PaymentManage/UpdatePaymentStatus', {
                Id: this.currentItem.id,
                打款金额: this.paymentForm.打款金额,
                目标状态: 状态,
            });
            this.payDialog = false;
            await this.loadList();
            this.service.提示.提示成功('操作成功');
        } finally {
            this.processing = false;
        }
    }

    get 默认打款金额(): number {
        const exam = this.exams.find((e) => e.id === this.selectedExamId);
        return exam?.默认打款金额 || 0;
    }

    openBatchPaymentDialog(): void {
        this.batchPaymentForm.打款金额 = this.默认打款金额;
        this.batchPayDialog = true;
    }

    async confirmBatchPayment(): Promise<void> {
        if (this.selected.length === 0) return;
        if (
            !(await this.service.提示.确认操作(
                `您确定要对选中的 ${this.selected.length} 条记录执行「已打款」操作吗？打款金额：${this.batchPaymentForm.打款金额} 元`,
                '警告',
                '批量操作'
            ))
        ) {
            return;
        }
        this.batchProcessing = true;
        try {
            await this.service.api.post('/ExpertColl/Manage/PaymentManage/BatchUpdatePaymentStatus', {
                Ids: this.selected.map((item) => item.id),
                目标状态: '已打款',
                打款金额: this.batchPaymentForm.打款金额,
            });
            this.batchPayDialog = false;
            this.selected = [];
            await this.loadList();
            this.service.提示.提示成功('批量操作成功');
        } finally {
            this.batchProcessing = false;
        }
    }

    async batchPayment(状态: string): Promise<void> {
        if (this.selected.length === 0) return;
        if (
            !(await this.service.提示.确认操作(
                `您确定要对选中的 ${this.selected.length} 条记录执行「${状态}」操作吗？`,
                '警告',
                '批量操作'
            ))
        ) {
            return;
        }
        this.batchProcessing = true;
        try {
            await this.service.api.post('/ExpertColl/Manage/PaymentManage/BatchUpdatePaymentStatus', {
                Ids: this.selected.map((item) => item.id),
                目标状态: 状态,
                打款金额: this.默认打款金额,
            });
            this.selected = [];
            await this.loadList();
            this.service.提示.提示成功('批量操作成功');
        } finally {
            this.batchProcessing = false;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private escapeCsv(value: any): string {
        const s = value == null ? '' : String(value);
        if (s.includes(',') || s.includes('"') || s.includes('\n')) {
            return `"${s.replace(/"/g, '""')}"`;
        }
        return s;
    }

    async exportCSV(): Promise<void> {
        const exam = this.exams.find((e) => e.id === this.selectedExamId);
        const examName = exam?.考试名称 || '未知';
        const header = '序号,专家姓名,身份证号码,手机号码,收款银行,收款银行卡号,开户支行,状态,打款金额,打款时间,登记时间,登记修改时间';
        const rows = this.items.map((item, i) => [
            i + 1,
            item.专家姓名,
            item.身份证号码,
            item.手机号码,
            item.收款银行,
            item.收款银行卡号,
            item.开户支行,
            item.状态,
            item.打款金额 != null ? Number(item.打款金额).toFixed(2) : '',
            item.打款时间 || '',
            item.登记时间 || '',
            item.登记修改时间 || '',
        ].map((v) => this.escapeCsv(v)).join(','));
        const csv = '\uFEFF' + header + '\n' + rows.join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const now = new Date();
        const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        link.download = `专家信息_${examName}_${ts}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    /**
     * 按模板规范导出「已登记」状态的数据到 xlsx 文件。
     * 从服务端下载原始模板 `发票代开发导入模板.xlsx`，用 exceljs 填充数据后导出。
     * 模板 Sheet「导入信息」结构：
     *   Row 1 = 注意事项（合并单元格）
     *   Row 2 = 分类行（合并单元格）
     *   Row 3 = 字段名行
     *   Row 4+ = 数据行（第4行已含固定值与公式，直接覆写）
     */
    async exportRegisteredCSV(): Promise<void> {
        const exam = this.exams.find((e) => e.id === this.selectedExamId);
        const examName = exam?.考试名称 || '未知';
        const registeredItems = this.items.filter((item) => item.状态 === '已登记');
        if (registeredItems.length === 0) {
            this.service.提示.提示错误('没有「已登记」状态的数据可导出');
            return;
        }

        this.exporting = true;
        try {
        // 1. 从服务端下载模板文件
        const templateResponse = await fetch(`${process.env.BASE_URL}发票代开发导入模板.xlsx`);
        if (!templateResponse.ok) {
            this.service.提示.提示错误('模板文件下载失败');
            return;
        }
        const templateBuffer = await templateResponse.arrayBuffer();

        // 2. 用 exceljs 加载模板
        const workbook = new Exceljs.Workbook();
        await workbook.xlsx.load(templateBuffer);
        const sheet = workbook.getWorksheet('导入信息') || workbook.worksheets[0];

        // --- 固定值 ---
        const 证件类型 = '居民身份证';
        const 国籍 = '中国';
        const 税收分类编码名称 = '其他咨询服务';
        const 项目名称 = '面试评委费';

        // 3. 从第4行开始填充数据（模板第4行已有固定值/公式，直接覆写）
        // 列映射（1-based）：
        //  A(1)=*姓名  B(2)=*证件类型  C(3)=*证件号码  D(4)=*国籍（地区）
        //  E(5)=联系电话  F(6)=联系地址  G(7)=开户银行  H(8)=银行账号
        //  I-L(9-12)=购买方（全空）
        //  M(13)=*税收分类编码名称  N(14)=*税收分类编码简称(保留VLOOKUP公式)
        //  O(15)=*项目名称  P(16)=规格型号  Q(17)=计量单位  R(18)=数量
        //  S(19)=单价（含税）  T(20)=*金额（含税）  U(21)=*税率/征收率
        //  V(22)=*金额（不含税）(保留公式)  W(23)=*税额(保留公式)  X(24)=*业务发生时间  Y(25)=备注
        const startRow = 4;
        registeredItems.forEach((item, idx) => {
            const row = sheet.getRow(startRow + idx);
            // A: 姓名
            row.getCell(1).value = item.专家姓名 || '';
            // B: 证件类型（固定值）
            row.getCell(2).value = 证件类型;
            // C: 证件号码
            row.getCell(3).value = item.身份证号码 || '';
            // D: 国籍（固定值）
            row.getCell(4).value = 国籍;
            // E: 联系电话（手机号码）
            row.getCell(5).value = item.手机号码 || '';
            // F: 联系地址（留空）
            row.getCell(6).value = null;
            // G: 开户银行（收款银行）
            row.getCell(7).value = item.收款银行 || '';
            // H: 银行账号（收款银行卡号）
            row.getCell(8).value = item.收款银行卡号 || '';
            // I-L: 购买方全空
            for (let c = 9; c <= 12; c++) row.getCell(c).value = null;
            // M: 税收分类编码名称（固定值）
            row.getCell(13).value = 税收分类编码名称;
            // N: 税收分类编码简称 — 保留模板已有的VLOOKUP公式
            //    模板中 N 列公式：IF(M<>"",VLOOKUP(M,填表说明!F$7:G$88,2,FALSE),"")
            //    第一行数据(行4)已有公式，后续行需复制
            if (idx === 0) {
                // 第4行已有公式，保持不变
            } else {
                const nFormula = `IF(M${startRow + idx}<>'',VLOOKUP(M${startRow + idx},填表说明!F$7:G$88,2,FALSE),'')`;
                row.getCell(14).value = { formula: nFormula };
            }
            // O: 项目名称（固定值）
            row.getCell(15).value = 项目名称;
            // P-R: 规格型号、计量单位、数量（留空）
            row.getCell(16).value = null;
            row.getCell(17).value = null;
            row.getCell(18).value = null;
            // S: 单价（含税）（留空）
            row.getCell(19).value = null;
            // T: 金额（含税）（留空）
            row.getCell(20).value = null;
            // U: 税率/征收率（留空）
            row.getCell(21).value = null;
            // V: 金额（不含税）— 保留模板公式
            if (idx === 0) {
                // 第4行已有公式
            } else {
                const vFormula = `IF(AND(T${startRow + idx}<>'',U${startRow + idx}<>""),T${startRow + idx}/(U${startRow + idx}+1),'')`;
                row.getCell(22).value = { formula: vFormula };
            }
            // W: 税额 — 保留模板公式
            if (idx === 0) {
                // 第4行已有公式
            } else {
                const wFormula = `IF(V${startRow + idx}<>'',V${startRow + idx}*U${startRow + idx},'')`;
                row.getCell(23).value = { formula: wFormula };
            }
            // X: 业务发生时间（留空）
            row.getCell(24).value = null;
            // Y: 备注（留空）
            row.getCell(25).value = null;
            row.commit();
        });

        // 4. 删除多余的数据行（模板预填了3000行公式，只保留有数据的行）
        const lastDataRow = startRow + registeredItems.length - 1;
        // 从 lastDataRow+1 到 sheet.rowCount 删除多余行
        // exceljs 不直接支持删除行，但可以清空多余行内容
        for (let r = lastDataRow + 1; r <= sheet.rowCount; r++) {
            const row = sheet.getRow(r);
            for (let c = 1; c <= 25; c++) {
                row.getCell(c).value = null;
            }
            row.commit();
        }

        // 5. 生成 xlsx 文件并下载
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const now = new Date();
        const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        link.download = `已登记专家_${examName}_${ts}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.service.提示.提示成功(`已导出 ${registeredItems.length} 条「已登记」数据`);
        } catch (e) {
            this.service.提示.提示错误('导出失败：' + (e as Error).message);
        } finally {
            this.exporting = false;
        }
    }

    get hasAnyPhoto(): boolean {
        return this.photoTypes.some((pt) => this.photoUrls[pt]);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async showExpertPhotos(item: any): Promise<void> {
        this.photoDialogItem = item;
        this.photoDialog = true;
        this.photoLoading = true;
        this.photoUrls = {};
        try {
            const result = await this.service.api.get('/ExpertColl/Manage/PaymentManage/GetExpertPhotoUrls', {
                infoId: item.id,
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const urls = result as Record<string, string>;
            if (urls) {
                for (const pt of this.photoTypes) {
                    const url = urls[pt];
                    if (url) {
                        try {
                            const dataUrl = await this.service.文件.获取文件到dataUrl(url);
                            this.$set(this.photoUrls, pt, dataUrl);
                        } catch {
                            this.$set(this.photoUrls, pt, null);
                        }
                    } else {
                        this.$set(this.photoUrls, pt, null);
                    }
                }
            }
        } catch {
            // 接口失败时所有照片显示暂无上传
        } finally {
            this.photoLoading = false;
        }
    }

    openFullPreview(photoType: string): void {
        const url = this.photoUrls[photoType];
        if (url) {
            this.fullPreviewUrl = url;
            this.fullPreviewDialog = true;
        }
    }

    async exportPhotos(): Promise<void> {
        if (!this.selectedExamId || this.items.length === 0) return;
        this.exportingPhotos = true;
        try {
            const blob = await this.service.api.getBlob('/ExpertColl/Manage/PaymentManage/ExportPhotos', {
                examId: this.selectedExamId,
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const exam = this.exams.find((e) => e.id === this.selectedExamId);
            const examName = exam?.考试名称 || '未知';
            const now = new Date();
            const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
            link.download = `已登记照片_${examName}_${ts}.zip`;
            link.click();
            window.URL.revokeObjectURL(url);
            this.service.提示.提示成功('照片导出成功');
        } catch (e) {
            this.service.提示.提示错误('照片导出失败：' + (e as Error).message);
        } finally {
            this.exportingPhotos = false;
        }
    }

    statusColor(状态: string): string {
        switch (状态) {
            case '已登记':
                return 'blue';
            case '已打款':
                return 'green';
            case '信息有误':
                return 'orange';
            case '无效':
                return 'red';
            default:
                return 'grey';
        }
    }
}
